export default __webpack_public_path__ + "static/media/R5C_8203.ea63ff53.jpg";